export const CreditsPerMonth = 100;
export const CreditsPerYear = 1200;
